import { create } from 'zustand';

interface SexOffendersState {
  checkinFrequency: number | null;
  setCheckinFrequency: (frequency: number) => void;
}

export const useSexOffendersStore = create<SexOffendersState>((set) => ({
  checkinFrequency: null,
  setCheckinFrequency: (frequency: number) =>
    set({ checkinFrequency: frequency }),
}));
